import { combineReducers } from '@reduxjs/toolkit';
import { rvdSlice } from './model/Rvd';

const rvdReducer = combineReducers({
  rvd: rvdSlice.reducer,
});

export default rvdReducer;
